import Vue from 'vue'
import InitData from '../store/configure'
import JSONBig from 'json-bigint-xk'
// callback(data.body)

export default {
  postLogin(params, callback) { // 登录
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/loginPhone', params)
    Vue.http.post('/v1/loginPhone', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  postRegister(params, callback) { // 注册
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/register', params)
    Vue.http.post('/v1/register', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  passengerWithOutLogin(params, callback) { // 免登
    console.log('免登接口')
    const headers = {
      sign: params.sign,
      clientId: params.clientId
    }
    delete params.sign
    delete params.clientId
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/passengerWithOutLogin', params)
    console.log(params)
    Vue.http.post('/v1/passengerWithOutLogin', params, {emulateJSON: true, headers}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  updateLoginData(obj, callback) { // 更新信息
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId
    }
    Vue.http.get('/v5/passenger/getPassengerInfo', {params}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  logoutUser(obj, callback) { // 注销
    var params = {
      'app_key': InitData.appKey,
      'phone': obj.phone,
      'openId': obj.openId
    }
    var url = InitData.weixinUrl + '/v5/passenger/logout'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => callback(JSONBig.parse(data.bodyText))
    )
  },
  getPassenger(params, callback) { // 获取 用户信息
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/passenger', params)
    Vue.http.get('/v1/passenger', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  putPassenger(params, callback) { // 编辑 用户信息
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/passenger', params)
    Vue.http.put('/v1/passenger', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getOpenId(obj, callback) { // 获取  微信 openID
    var params = {
      'app_key': InitData.appKey,
      'code': obj.jsCode,
      'wxAppId': obj.wxAppId
    }
    Vue.http.get('/v1/weChatOpenId', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(JSON.stringify(data.body)))
    })
  },
  getWeChatToken(obj, callback) { // 授权
    var params = {
      'app_key': InitData.appKey,
      'wxAppId': obj.wxAppId
    }
    Vue.http.get('/v1/weChatToken', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(JSON.stringify(data.body)))
    })
  },
  postloginOpenId(obj, callback) { // 获取  微信 openID
    var params = {
      'app_key': InitData.appKey,
      'open_id': obj.open_id,
      'timeStamp': Date.parse(new Date()) / 1000
    }
    Vue.http.post('/v1/loginOpenId', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(JSON.stringify(data.body)))
    })
  },
  getCheckUser(params, callback) { // 检查账户是否存在
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/check', params)
    Vue.http.get('/v1/check', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getImgCode(params, callback) { // 获取图片验证码
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/picCode', params)
    Vue.http.get('/v1/picCode', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  postCheckCode(params, callback) { // 检验验证码是否正确
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/checkCode', params)
    Vue.http.post('/v1/checkCode', params, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },
  getSmsCode(params, callback) { // 获取 短信验证码
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/smsCode', params)
    Vue.http.get('/v1/smsCode', {params}, {emulateJSON: true}).then((data) => {
      callback(JSONBig.parse(data.bodyText))
    })
  },

  getUsePic(params, fn) {
    Vue.http.options.headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/block/pic', params)
    Vue.http.post('/v1/block/pic', params, {emulateJSON: true}).then(res => {
      fn(JSONBig.parse(res.bodyText))
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/mc.js